import './styles.css';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '../../hooks/useDrawer';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import { NavbarDepositIcon } from '../svg/NavbarDepositIcon';
import { NavbarCherry } from '../svg/NavbarCherry';
import { useApiContext } from 'react-easyrocket';
import { SearchMobile } from '../svg/Vip';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';

export const Navbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const { isAuthenticated } = useApiContext();
  const { openModal } = useModalContext();
  const location = useLocation();
  const isLiveGames = location.pathname.includes('/games/live');
  const { closeDrawer, isLeftDrawerOpen } = useDrawer();
  const { startRegistration } = useAuthFlow();

  return (
    <div className={classNames('z-20', isLeftDrawerOpen && 'blured')}>
      <div className="navbar gap-2">
        <button
          title={`${t('general.providerList')}`}
          onClick={() => {
            if (!isAuthenticated) {
              startRegistration();
            } else {
              location.pathname.includes('account')
                ? navigate(ROUTE.ACCOUNT_DEPOSIT.get())
                : openModal('DEPOSIT');
            }
          }}
          className={classNames(
            'navbar-button flex-1 flex justify-center items-center gap-[5px] font-normal',
            !isAuthenticated &&
              'border-[1px] border-solid border-n_signup_button_border signupButton'
          )}>
          {isAuthenticated && <NavbarDepositIcon />}
          <p className="font-bold uppercase text-[15px]">
            {!isAuthenticated ? t('general.signUp') : t('general.deposit')}
          </p>
        </button>
        <div
          className="p-2 flex flex-row justify-center items-center border-none rounded-[50px] w-[50px] h-[50px] navbar-search"
          onClick={() => {
            openModal('SEARCH', { props: { searchTab: 'games' } });
          }}>
          <SearchMobile className="relative w-auto " />
        </div>
        <button
          title={`${t('general.providerList')}`}
          onClick={() => {
            closeDrawer();
            navigate(isLiveGames ? ROUTE.GAMES_SLOTS.get() : ROUTE.GAMES_LIVE.get());
          }}
          className={classNames(
            'navbar-button flex flex-row justify-center flex-1 items-center font-normal',
            isLiveGames ? 'gap-[5px]' : ''
          )}>
          {isLiveGames ? (
            <>
              <NavbarCherry />
              <p className="font-bold uppercase text-[15px] pr-[5px]">{t('general.games')}</p>
            </>
          ) : (
            <>
              <p className="font-bold relative uppercase text-[15px] pl-[5px] after:absolute after:content-[''] after:w-[9px] after:h-[9px] after:rounded-full after:bg-gc_bg_label_live after:left-[-10px] after:top-[50%] after:translate-y-[-50%] after:animate-blinkRed">
                {t('general.liveCasino')}
              </p>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
